export const GaEventActionConstants = {
  UserLoginSuccess: "userLoginSuccess",
  UserLoginFail: "userLoginFail"
}